<template>
  <div>
    <h2 class="page-header">{{ $t('academicYear.academicYear') }}</h2>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('academicYear.academicYear') }}
                <span class="text-danger">*</span></label>
              <input v-model="model.ac_year" type="text" class="form-control"
                :class="{ 'is-invalid': errors.has('ac_year') }" :placeholder="$t('academicYear.enterAcademicYear')" />
              <div class="invalid-feedback" v-if="errors.has('ac_year')">
                {{ errors.first('ac_year') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('academicYear.beginDate')
              }}<span class="text-danger">*</span></label>
              <ts-date-picker-input v-model="model.ac_start">
              </ts-date-picker-input>
              <div style="color:#cc4946;margin:4px 0 0">
                {{ errors.first('ac_start') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('academicYear.endDate')
              }}<span class="text-danger">*</span></label>
              <ts-date-picker-input v-model="model.ac_stop">
              </ts-date-picker-input>
              <div style="color:#cc4946;margin:4px 0 0">
                {{ errors.first('ac_stop') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('academicYear.status')
              }}<span class="text-danger">*</span></label>
              <select v-model="model.ac_status_id" class="form-control"
                :class="{ 'is-invalid': errors.has('ac_status_id') }">
                <option value="">{{ $t('select') }}</option>
                <option v-for="(ac, index) in acStatus" :key="index" :value="ac.ac_status_id">{{
                  ac.ac_status_description }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('ac_status_id')">
                {{ errors.first('ac_status_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <fieldset>
                <legend>{{ $t('academicYear.batches') }}</legend>
                <div class="ts-space-y-2">
                  <table class="ts-w-full">
                    <thead>
                      <tr>
                        <th style="width: 50%;">
                          {{ $t('academicYear.batch') }}
                        </th>
                        <th style="width: 44%;">
                          {{ $t('academicYear.remarks') }}
                        </th>
                        <th class="ts-text-right ts-cursor-pointer" style="width: 6%;">
                          <a href="#" class="ts-text-blue-500" @click.prevent="addItem(batch)">
                            <i class="fa fa-plus"></i>
                          </a>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="batch in model.batches">
                        <td class="ts-py-1 ts-pr-1">
                          <input v-model="batch.batch_name" type="text" class="form-control"
                            :class="{ 'is-invalid': errors.has('batch') }" :placeholder="$t('academicYear.batch')" />
                        </td>
                        <td class="ts-py-1">
                          <input v-model="batch.remarks" type="text" class="form-control"
                            :class="{ 'is-invalid': errors.has('remarks') }"
                            :placeholder="$t('academicYear.remarks')" />
                        </td>
                        <td class="ts-text-right ts-cursor-pointer">
                          <a href="#" @click.prevent="removeItem(batch)">
                            <i class="fa fa-trash text-red"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </fieldset>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" @click="cancel" class="btn btn-default mr-2">{{ $t('cancel') }}</ts-button>
              <ts-button v-if="!updating" :waiting="waiting" class="btn btn-primary" @click.prevent="store">{{
                $t('save') }}</ts-button>
              <ts-button v-if="updating" @click="update" :waiting="waiting" class="btn btn-primary">{{ $t('Update')
              }}</ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetchData" @fetched="fetchData = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import DataTable from './table'
import TsButton from '../../components/common/TsButton'
export default {
  name: 'academic-year-form',
  components: { TsButton, DataTable },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      updating: false,
      fetchData: false,
      model: {
        ac_year_id: '',
        ac_year: '',
        ac_start: '',
        ac_stop: '',
        ac_status_id: '',
        batches: [
          { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' },
          { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' },
          { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' },
        ],
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('academicYear', ['acStatus', 'edit_data'])
  },
  methods: {
    addItem(batch) {
      this.model.batches.push({ ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' })
    },
    removeItem(batch) {
      const index = this.model.batches.indexOf(batch)
      if (index > -1) {
        this.model.batches.splice(index, 1)
      }
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('academicYear/store', Object.assign({}, this.model))
        .then(response => {
          this.waiting = false
          this.fetchData = true
          this.clearInput()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('academicYear/update', Object.assign({}, this.model))
        .then(response => {
          this.waiting = false
          this.fetchData = true
          this.cancel()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.updating = true
        this.model.ac_year_id = this.edit_data.ac_year_id
        this.model.ac_year = this.edit_data.ac_year
        this.model.ac_start = this.edit_data.ac_start
        this.model.ac_stop = this.edit_data.ac_stop
        this.model.ac_status_id = this.edit_data.ac_status_id
        this.model.batches = this.edit_data.batches
      }
    },
    clearInput() {
      this.model.ac_year_id = ''
      this.model.ac_year = ''
      this.model.ac_start = ''
      this.model.ac_stop = ''
      this.model.ac_status_id = ''
      this.model.batches = [
        { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' },
        { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' },
        { ac_year_id: null, batch_id: null, batch_name: 'BATCH', remarks: '' }
      ]
    },
    cancel() {
      this.fetchData = true
      this.updating = false
      this.$store.commit('academicYear/SET_EDIT_DATA', {})
      this.$router.push({ name: 'academic-year' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('academicYear/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetchData = true
      this.updating = false
    }
  },
  watch: {
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.setEditData()
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('academicYear/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
